/**
 * @file directives.module.ts
 */
import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { PhoneNumberFormatDirective } from './phone-number-format.directive';
import { TruncateTextWithEllipsesDirective } from './truncate-text-with-ellipses.directive';


@NgModule({
    declarations: [
        PhoneNumberFormatDirective,
        TruncateTextWithEllipsesDirective
    ],
    imports: [CommonModule],
    exports: [PhoneNumberFormatDirective, TruncateTextWithEllipsesDirective]
})
export class DirectivesModule { }
